module.exports = __webpack_public_path__ + "img/half-vector.ce92e859.png";